import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class FeedbackToSlackAccessToken extends PrimitiveValueObject<string> {
  static create(value: string): FeedbackToSlackAccessToken {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new FeedbackToSlackAccessToken(value);
  }
}
